import React, {useContext, useState} from 'react';
import STC from '../../../../../../../../STCLibrary/STCFactory/STCFactory';
import PassportForm from './PassportForm/PassportForm';
import { FaExclamation } from "react-icons/fa";
import { PassengersContext } from '../../../PassengersHome';

export default function ViewPassengerPassportDetails({passenger}){

    const [editPassport, setEditPassport] = useState(false);

    const getPax = useContext(PassengersContext)

    const handleSavedPassport = () => {
        setEditPassport(false);
        getPax();
    }

    return(
        <div>
            {!passenger.passport &&
            <div style={{display: "flex", justifyContent: "center"}}>
                <STC.Button className={editPassport ? 'clear' : ''} style={{width: "90%",}} size='sm' onClick={() => setEditPassport(!editPassport)}>
                    {editPassport ? 'Cancel' : <>Add Passport Details <FaExclamation className="passport-notification"/></>}
                </STC.Button>
            </div>}
            {editPassport ? 
                <PassportForm passenger={passenger} handleSavedPassport={handleSavedPassport}/> 
                : 
                passenger.passport  &&
                <div className='mt-2'>
                    <hr/>
                    <strong>Passport Details:</strong>
                    
                    <div className='view-passenger-tour-info-line'>
                        <strong>Document Type: </strong>
                        <>{passenger.passport?.idDocType ?? 'Not provided'}</>
                    </div>
                    <div className='view-passenger-tour-info-line'>
                        <strong>Passpport Number:</strong>
                        <>{passenger.passport?.docNumber ?? 'Not provided'}</> 
                    </div>
                    <div className='view-passenger-tour-info-line'>
                        <strong>Country of Issue:</strong> 
                        <>{passenger.passport?.countryOfIssue.name ?? 'Not provided'}</> 
                    </div>
                    <div className='view-passenger-tour-info-line'>
                        <strong>Nationality:</strong> 
                        <>{passenger.passport?.nationality.name ?? 'Not provided'}</> 
                    </div>
                    <div className='view-passenger-tour-info-line'>
                        <strong>Expiry Date:</strong> 
                        <>{passenger.passport?.expiryDate ?? 'Not provided'}</> 
                    </div>
                    {/* <div className='view-passenger-tour-info-line'>
                        <strong>Biometric:</strong> 
                        <>                        
                            {passenger.passport ?
                                passenger.passport.isBiometric ? 'YES' : 'NO'
                                : 
                                'Not provided'
                            }
                        </>

                        </div> */}
                </div>
                
                
            }
            
        </div>
    )
}